exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-f99275d2] {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}\n.claim[data-v-f99275d2] {\n  position: fixed;\n  z-index: 999999;\n  top: 0.5rem;\n  right: 2.5rem;\n  width: 7.3rem;\n}", ""]);

// exports
